import React, { useEffect, useState } from "react";
import { Loadable, useGlobalStore } from '../../../common';
import { ColorPicker } from '../../../common/colorPicker'
import { Formik } from "formik";
import Helmet from 'react-helmet';
import { infoToastify } from "../../../util/toast"
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../partials/content/Portlet";

import {
  Button,
  Box,
  TextField,
  Grid,
  InputLabel,
  Card,
  CardHeader,
  CardContent,
  FormControlLabel,
  Switch,
  FormGroup,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Chip,
  CircularProgress,
  IconButton,
  Autocomplete,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FooterLinkArray } from "./FooterLinkArray";
import { convertDateToLocal } from "../../../util/date";
import EditIcon from '@mui/icons-material/Edit';
import { selectSessionUserPreferredClientId } from "../../../store/selectors/session";

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {
    flexGrow: 1,
  },
  textField: {
    margin: theme.spacing(1),
    width: '80%'
  },
  label: {
    margin: theme.spacing(1),
  },
  switch: {
    margin: theme.spacing(1),
  },
  cardTop: {
    marginTop: theme.spacing(1),
  },
  textArea: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '80%',
  },
  checkbox: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(0),
  },
  deploymentHeaderText: {
    fontSize: '15px',
    fontWeight: '500',
    marginBottom:'5px'
  },
  urlString:{
    fontSize:'12px'
  },
  underline:{
    textDecoration:'underline'
  }
}));

const TOOLTIP_TEXT_PRIMARY = 'Primary color would be displayed on Buttons etc.'
const TOOLTIP_TEXT_SECONDARY = 'Secondary color would be displayed on Borders, Radio button etc.'

export default function BrandConfigurationPage(props) {

  const {
    brand, brandCreatePending, brandUpdatePending, initialValues, intl, mode, clientBrandId, pricerPayerContracts, isPercentageOfChargeValue, pricerPayerContractObj,
    getNegotiatedRatesSignOffPending, signOffPending, signOff, mrfs, publishMRFloading, deploymentStatus,getDeploymentStatusPending, saveSelfPayTogglePending,
    saveSelfPayPricerPayerContractPending,
    actions: { brandCreate, brandUpdate, getBrand, negotiatedRatesSignOff, getNegotiatedRatesSignOff, publishMRFs,getDeploymentStatus,
      getPricerPayerContractsTiny, getSelfPayPricerPayerContract, saveSelfPayPricerPayerContract, saveSelfPayToggle,getConfiguration }
  } = props;

  const [openMRFConfirmationDialog, setOpenMRFConfirmationDialog] = useState(false);
  const [openMRFPublishConfirmationDialog, setOpenMRFPublishConfirmationDialog] = useState(false);
  const [openMRFPublishDialog, setOpenMRFPublishDialog] = useState(false);
  const [attesterName, setAttesterName] = useState('');
  const [editAttesterNameOnly, setEditAttesterNameOnly] = useState(false);
  const [pricerPayerContract, setPricerPayerContract] = useState(pricerPayerContractObj || null);
  const [pricerPayerContractError, setPricerPayerContractError] = useState('');
  const [isPercentageOfCharge, setIsPercentageOfCharge] = useState(isPercentageOfChargeValue ?? true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isContractChanged, setIsContractChanged] = useState(false);
  const clientId = useGlobalStore((state) => selectSessionUserPreferredClientId(state));
  useEffect(() => {
    getBrand();
  }, []);

  useEffect(() => {
    if (clientId) {
      getConfiguration(clientId);
    }
  }, [clientId]);

  useEffect(() => {
    setIsPercentageOfCharge(isPercentageOfChargeValue ?? true);
  }, [isPercentageOfChargeValue]);

  useEffect(() => {
    setPricerPayerContract(pricerPayerContractObj || null);
  }, [pricerPayerContractObj]);

  useEffect(() => {
    getNegotiatedRatesSignOff();
  }, [getNegotiatedRatesSignOff]);

  useEffect(() => {
    getDeploymentStatus()
  }, [getDeploymentStatus]);

  useEffect(() => {
    getPricerPayerContractsTiny();
  }, [getPricerPayerContractsTiny]);

  useEffect(() => {
    getSelfPayPricerPayerContract();
  }, [getSelfPayPricerPayerContract]);

  // useEffect(() => {
  //   if (!isPercentageOfCharge && !pricerPayerContract) {
  //     setPricerPayerContractError("This field is required.");
  //   } else {
  //     setPricerPayerContractError("");
  //   }
  // }, [isPercentageOfCharge]);

  const [file, setFile] = useState(null);

  const classes = useStyles();
  const isEdit = brand && brand.brandId;

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  }

  function handleAddLink(values, setValues) {
    values.footerLinks.push({
      label: '',
      url: '',
    });
    setValues(values);
  }

  function handleMRFCheckboxChange(value, signOffAttesterName) {
    if(value === true) {
      setOpenMRFConfirmationDialog(true);
      setAttesterName(signOffAttesterName);
      setEditAttesterNameOnly(false);
    }
  }

  function handleEditAttesterName(signOffAttesterName) {
    setEditAttesterNameOnly(true);
    setOpenMRFConfirmationDialog(true);
    setAttesterName(signOffAttesterName);
  } 

  function handleMRFConfirmation() {
    setOpenMRFConfirmationDialog(false);
    negotiatedRatesSignOff(attesterName?.trim() ?? "", editAttesterNameOnly, handleSignedOffCallback);
  }

  function handleSignedOffCallback() {
    getNegotiatedRatesSignOff();
    setOpenMRFPublishConfirmationDialog(true);
  }

  function handleMRFConfirmationClose() {
    setOpenMRFConfirmationDialog(false);
    setEditAttesterNameOnly(false);
  }

  function handleCallback() {
    setOpenMRFPublishDialog(true);
  }

  function handleMRFPublishDialogClose() {
    setOpenMRFPublishDialog(false);
  }

  function handleMRFPublishConfirmation() {
    handleMRFPublishConfirmationClose();
    setEditAttesterNameOnly(false);
    publishMRFs(handleCallback);
  }

  function handleMRFPublishConfirmationClose() {
    setOpenMRFPublishConfirmationDialog(false);
    setEditAttesterNameOnly(false);
  }

  const handleSavePricerPayerContract = () => {
    if(!pricerPayerContractError && pricerPayerContract && pricerPayerContract.id) {
      saveSelfPayPricerPayerContract(pricerPayerContract.id);
    }
  }

  return (<>
    <Loadable loading={brandCreatePending || brandUpdatePending || getNegotiatedRatesSignOffPending || signOffPending || publishMRFloading }>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validate={values => {
          const errors = {};

          if (!values.logoRedirectionURL) {
            errors.logoRedirectionURL = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if (!values.ein) {
            errors.ein = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          if (values.cashDiscountPercent!=0 && !values.cashDiscountPercent) {
            errors.cashDiscountPercent = intl.formatMessage({
              id: "AUTH.VALIDATION.REQUIRED_FIELD"
            });
          }

          const linkErrors = values.footerLinks.map((link) => {
            const linkErrors = {};
            let hasError = false;

            if (!link.label) {
              linkErrors['label'] = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
              hasError = true;
            }

            if (!link.url) {
              linkErrors['url'] = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
              hasError = true;
            }

            if (hasError) {
              return linkErrors;
            }

            return false;
          });

          const filteredArray = linkErrors.filter(value => Object.keys(value).length > 0);

          if (filteredArray.length > 0) {
            errors['footerLinks'] = linkErrors;
          }
          return errors;
        }}
        onSubmit={(values) => {
          let payload = {
            DomainName: clientBrandId,
            ThemeName: values.themeName,
            ThemeMetadata: JSON.stringify(values.themeMetadata),
            LogoRedirectionURL: values.logoRedirectionURL,
            EIN: values.ein,
            cashDiscountPercent: values.cashDiscountPercent,
            FooterLinks: JSON.stringify(values.footerLinks),
            isOutOfPocketCalculationEnabled: values.isOutOfPocketCalculationEnabled,
            isHealthTalkAIEnabled: false,
          }

          const formData = new FormData();
          if (file) {
            formData.append('File', file);
          }
          formData.append('Payload', JSON.stringify(payload));

          const callback = () => {
            infoToastify(
              <>
                <b>Brand Configuration Saved</b>
                <br />
                Your changes have been saved successfully.
              </>
            );
            setIsEditMode(false);
            setFile(null);
            setFileInputKey(Date.now());
            setIsContractChanged(false);
            getBrand();  
          };

          if (mode === 'create') {
            brandCreate(formData, callback);
          }
          else {
            brandUpdate(brand.brandId, formData, callback);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setValues,
          dirty,
          resetForm,
        }) => (
          <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
            <Helmet title="Brand Configuration" />
            <Portlet>
              <PortletHeader
                title={isEdit ? 'Brand Configuration' : 'Brand Configuration'}
                toolbar={
                  <PortletHeaderToolbar>
                    {!isEditMode ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setIsEditMode(true)}
                      type="button"
                    >
                      Edit
                    </Button>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          disabled={(!dirty && !file && !isContractChanged) || brandCreatePending || brandUpdatePending ||(!isPercentageOfCharge && !pricerPayerContract)}
                        >
                          Save
                        </Button>
                        <Button
                        variant="outlined"
                        onClick={() => {
                          setIsEditMode(false);
                          setFile(null);                    
                          setFileInputKey(Date.now());
                          resetForm();
                          setIsContractChanged(false);
                          getBrand();
                          getSelfPayPricerPayerContract();
                        }}
                        type="button"
                        className={classes.button}
                      >
                        Cancel
                      </Button>
                      </>
                    )}
                  </PortletHeaderToolbar>
                }
              />
              <PortletBody>
                <div className={classes.root}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8} lg={6}>
                      <Card variant="outlined">
                        <CardHeader title="Branding" />
                        <CardContent>
                          <TextField
                            key={fileInputKey}
                            type="file"
                            label="Upload Logo"
                            name="logoUpload"
                            className={classes.textField}
                            margin="normal"
                            onChange={handleFileChange}
                            disabled={!isEditMode}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <TextField
                            label="Logo URL"
                            name="logoRedirectionURL"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled={!isEditMode}
                            value={values.logoRedirectionURL}
                            helperText={touched.logoRedirectionURL && errors.logoRedirectionURL}
                            error={Boolean(touched.logoRedirectionURL && errors.logoRedirectionURL)}
                          />
                          <TextField
                            label="EIN"
                            name="ein"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled={!isEditMode}
                            value={values.ein}
                            helperText={touched.ein && errors.ein}
                            error={Boolean(touched.ein && errors.ein)}
                          />
                          <TextField
                            type="number"
                            label="Self Pay"
                            name="cashDiscountPercent"
                            className={classes.textField}
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled={ !isEditMode || !isPercentageOfCharge}
                            value={values.cashDiscountPercent}
                            helperText={touched.cashDiscountPercent && errors.cashDiscountPercent}
                            error={Boolean(touched.cashDiscountPercent && errors.cashDiscountPercent)}
                          />
                          
                          <FormControlLabel
                            control={
                              <Switch
                                name="isOutOfPocketCalculationEnabled"
                                checked={values.isOutOfPocketCalculationEnabled}
                                onChange={handleChange}
                                disabled={!isEditMode}
                                onBlur={handleBlur}
                                className={classes.switch}
                                value={values.isOutOfPocketCalculationEnabled}
                              />
                            }
                            label="Out Of Pocket Calculation"
                          />
                          <Box display="flex" alignItems="center" gap={1} sx={{marginLeft: '11px'}}>
                            <Typography fontWeight={400}>Contract</Typography>
                            <Switch
                                name="isPercentageOfCharge"
                                checked={isPercentageOfCharge}
                                onChange={(e, checked) => {
                                  setIsPercentageOfCharge(checked);
                                  setIsContractChanged(true)
                                  if (checked) {
                                    setPricerPayerContract(null);
                                    setPricerPayerContractError("This field is required.");
                                  }
                                  saveSelfPayToggle(checked);
                                }}
                                disabled={ !isEditMode || saveSelfPayTogglePending}
                                color="primary"
                            />
                            <Typography fontWeight={400}>Percentage of Charge</Typography>
                          </Box>

                          <Box display="flex" alignItems="center" gap={1} sx={{marginLeft: '11px'}}>
                            {isPercentageOfCharge === false && <>
                              <Autocomplete
                                fullWidth
                                value={pricerPayerContract}
                                disableClearable={false}
                                disabled={!isEditMode}
                                onChange={(e, value) => {
                                  setPricerPayerContract(value);
                                  setIsContractChanged(true);
                                  if(value) {
                                    setPricerPayerContractError('');
                                  }
                                  else {
                                    setPricerPayerContractError("This field is required.");
                                  }
                                }}
                                isOptionEqualToValue={(option, value) => option?.id == value?.id}
                                options={pricerPayerContracts}
                                getOptionLabel={(option) => option?.displayName || ''}
                                getOptionDisabled={option => {
                                    if (!option.includeInMachineReadable) {
                                        return true;
                                    }
                                    return false;
                                }}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        required
                                        name="pricerPayerContract"
                                        label="Payer Contract"handleSave 
                                        error={Boolean(pricerPayerContractError)}
                                        helperText={pricerPayerContractError || ''}
                                        margin="normal" />}
                              />

                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={handleSavePricerPayerContract}
                                disabled={!isEditMode || Boolean(pricerPayerContractError) || saveSelfPayPricerPayerContractPending}
                              >
                                Save
                              </Button>
                              </>
                            }
                          </Box>
                        </CardContent>
                      </Card>

                      <Card variant="outlined" className={classes.cardTop}>
                        <CardHeader title="Deployment" />
                        <CardContent>

                                   {!getDeploymentStatusPending  ?  
                                    <Grid container>
                                        <Grid item xs={8}> 
                                            {deploymentStatus?.deployed ? 
                                              <a className={`${classes.urlString} ${classes.underline}`} target="_blank" href={deploymentStatus?.deploymentUrl || ''} >
                                                {deploymentStatus?.deploymentUrl || 'NA'}
                                              </a> :
                                              <span className={classes.urlString}>{deploymentStatus?.deploymentUrl || 'NA'}</span> }
                                        </Grid>
                                        <Grid item xs={4} sx={{textAlign:"right"}}>
                                              <Chip
                                                label={deploymentStatus?.deployed ? 
                                                  'DEPLOYED':
                                                  'PENDING'}
                                                  sx={{
                                                    color:"white",
                                                    borderRadius: '5px',
                                                    height: '18px', 
                                                    fontWeight: '400', 
                                                    paddingTop: '1px',
                                                    background:deploymentStatus?.deployed ? '#95c83e' :'#5c79ff' 
                                                  }}
                                                  
                                              />

                                        </Grid>

                                    </Grid>:
                                    <CircularProgress 
                                      size={25}
                                      color="secondary"
                                      className="loading-overlay-image loading-overlay-image-loading" />
                                      
                                      }
                        </CardContent>
                        </Card>
                      <Card variant="outlined" className={classes.cardTop}>
                        <CardHeader title="Footer Links"
                          action={
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              className={classes.button}
                              disabled={!isEditMode}
                              onClick={() => handleAddLink(values, setValues)}
                            >
                              Add
                            </Button>
                          }
                        />
                        <CardContent>
                          <FooterLinkArray
                            footerLinks={values.footerLinks}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            disabled={!isEditMode}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={8} lg={6}>
                      <Card variant="outlined">
                        <CardHeader title="Color Selection" />
                        <CardContent>
                          <Grid container>
                            <Grid item xs={12} md={4}>
                              <InputLabel className={classes.label}>Primary Color</InputLabel>
                            </Grid>
                            <Grid item xs={12} md={8}>
                              <ColorPicker
                                tooltip={TOOLTIP_TEXT_PRIMARY}
                                value={values.themeMetadata.primary}
                                onChange={(color) => setFieldValue("themeMetadata.primary", color)}
                                disabled={!isEditMode}
                              />
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid item xs={12} md={4}>
                              <InputLabel className={classes.label}>Secondary Color</InputLabel>
                            </Grid>
                            <Grid item xs={12} md={8}>
                              <ColorPicker
                                tooltip={TOOLTIP_TEXT_SECONDARY}
                                value={values.themeMetadata.secondary}
                                onChange={(color) => setFieldValue("themeMetadata.secondary", color)}
                                disabled={!isEditMode}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                      {signOff && (
                        <Card variant="outlined" className={classes.cardTop}>
                          <CardHeader title="Latest MRF Template Information" />
                          <CardContent>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>MRF Date </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <Typography className={classes.label}>{signOff?.mrfDate ? convertDateToLocal(signOff?.mrfDate) : ''} </Typography>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>MRF Version </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <Typography className={classes.label}>{`2.0.0`} </Typography>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>Last Updated </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <Typography className={classes.label}>{signOff?.signedOffUpdatedOn ? convertDateToLocal(signOff?.signedOffUpdatedOn) : ''} </Typography>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>Last Updated By </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <Typography className={classes.label}>{signOff?.signedOffUpdatedBy ?? ''} </Typography>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>Attester Name </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.label} sx={{ mr: 1 }}>{signOff?.attesterName ?? ''} </Typography>
                                {signOff?.signedOff === 'true' &&
                                  <IconButton
                                    size="small"
                                    onClick={() => handleEditAttesterName(signOff?.attesterName ?? '')}
                                    aria-label="Edit Attester Name"
                                    disabled={!isEditMode}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                }
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={4}>
                                <InputLabel className={classes.label}>Sign off </InputLabel>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <Typography className={classes.label}>{`To the best of its knowledge and belief, this hospital has included all applicable standard charge information in accordance with the requirements of 45 CFR 180.50, and the information encoded is true, accurate, and complete as of the date in the file. This hospital has included all payer-specific negotiated charges in dollars that can be expressed as a dollar amount. For payer-specific negotiated charges that cannot be expressed as a dollar amount in the machine-readable file or not knowable in advance, the hospital attests that the payer-specific negotiated charge is based on a contractual algorithm, percentage or formula that precludes the provision of a dollar amount and has provided all necessary information available to the hospital for the public to be able to derive the dollar amount, including, but not limited to, the specific fee schedule or components referenced in such percentage, algorithm or formula.`} </Typography>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <FormControlLabel
                                  className={classes.checkbox}
                                  control={
                                      <Checkbox
                                        disabled={signOff?.signedOff === 'true'}
                                        checked={signOff?.signedOff === 'true'}
                                        onChange={(event) =>
                                          handleMRFCheckboxChange(
                                            event.target.checked,
                                            signOff?.attesterName ?? ''
                                          )
                                        }
                                        name="signedOff"
                                        color="primary"
                                      />
                                  }
                                  label="I accept the MRF updates"
                                />
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      )}

                    </Grid>
                  </Grid>
                </div>
              </PortletBody>
            </Portlet>
          </form>
        )}
      </Formik>
    </Loadable>
    <Dialog maxWidth='xs' fullWidth open={openMRFConfirmationDialog} onClose={handleMRFConfirmationClose}>
      <DialogTitle>
        {editAttesterNameOnly === true ? `Update Attester Name`: `Confirmed SIGN OFF?`}
      </DialogTitle>
      <DialogContent>
          <TextField
            type="text"
            label="Attester Name *"
            name="attesterName"
            className={classes.textField}
            margin="normal"
            onChange={(e) => setAttesterName(e.target.value)}
            value={attesterName}
            inputProps={{ maxLength: 250 }}
          />

          {!editAttesterNameOnly && 
            <DialogContentText sx={{margin: '8px'}}>
              {` Are you sure you want to Sign off?`}
            </DialogContentText>
          }
      </DialogContent>
      <DialogActions>
          <Button onClick={handleMRFConfirmationClose}>
              Cancel
          </Button>
          <Button
              disabled={!attesterName}
              onClick={handleMRFConfirmation}
              color="primary" variant="contained">
              {editAttesterNameOnly === true ? `Save`: `Sign off`}
          </Button>
      </DialogActions>
    </Dialog>
    <Dialog maxWidth='sm' fullWidth open={openMRFPublishConfirmationDialog && !getNegotiatedRatesSignOffPending} onClose={handleMRFPublishConfirmationClose}>
      <DialogTitle className='py-3'>
          Publish MRFs?
      </DialogTitle>
      <DialogContent dividers>
          <DialogContentText>
          {!editAttesterNameOnly && <Typography>You signed off successfully!</Typography>}
            <Typography>{`Do you want to publish the MRFs?`}</Typography>
          </DialogContentText>
      </DialogContent>
      <DialogActions className='p-4'>
          <Button variant="contained" onClick={handleMRFPublishConfirmationClose}>
              Cancel
          </Button>
          <Button
              variant="contained"
              onClick={handleMRFPublishConfirmation}
              color="primary">
              Publish
          </Button>
      </DialogActions>
    </Dialog>
    <Dialog maxWidth='lg' fullWidth open={openMRFPublishDialog}>
      <DialogTitle className='py-3'>
          MRFs
      </DialogTitle>
      <DialogContent dividers>
          <Grid>
              {mrfs.map(item => <Grid spacing={2} container className='pt-1'>
                  <Grid item xs={2}>
                      <b>{item.name}</b>
                  </Grid>
                  <Grid item xs={6}>
                      {item.message}
                  </Grid>
                  <Grid item xs={4}>
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                          {item.url}
                      </a>
                  </Grid>
              </Grid>
              )}
          </Grid>
      </DialogContent>
      <DialogActions className='p-4'>
          <Button variant="contained" onClick={handleMRFPublishDialogClose}>
              Close
          </Button>
      </DialogActions>
    </Dialog>
  </>);
}
